<template>
	<van-empty description="您访问的页面丢失了">
		<van-button round type="default" class="bottom-button" @click="goback()">
			返回上一页
		</van-button>
	</van-empty>
</template>

<script>
	export default {
		name: "page404",
		data() {
			return {};
		},
		mounted() {},
		methods: {
			goback() {
				this.$router.go(-1); //返回上一层
			},
		}
	};
</script>

<style scoped></style>
